import { supabase } from '../lib/supabase'
import type { MessageShare } from '../types/inbox'

export async function createMessageShare(input: {
  conversationId: string
  messageIds: string[]
  sharedWithUserId: string
  note?: string | null
  expiresAt?: string | null
}): Promise<MessageShare> {
  const { data, error } = await supabase
    .from('message_shares')
    .insert({
      conversation_id: input.conversationId,
      message_ids: input.messageIds,
      shared_with_user_id: input.sharedWithUserId,
      note: input.note || null,
      expires_at: input.expiresAt || null,
    })
    .select('*')
    .single()
  if (error) throw error
  return data as MessageShare
}

export async function fetchMessageSharesForUser(userId: string): Promise<MessageShare[]> {
  const { data, error } = await supabase
    .from('message_shares')
    .select('*')
    .eq('shared_with_user_id', userId)
    .order('created_at', { ascending: false })
  if (error) throw error
  return (data || []) as MessageShare[]
}

export async function fetchMessagesForShare(share: MessageShare) {
  if (!share.message_ids?.length) return []
  const { data, error } = await supabase
    .from('messages')
    .select('*')
    .in('id', share.message_ids)
    .order('created_at', { ascending: true })
  if (error) throw error
  return data || []
}
